import {
  getRequestSign,
  getCurrentUser,
  setCurrentUser,
  setCurrentAuth,
  clearLocalStorage
} from "../utils/api-params";

const authProvider =
{
  login: ({ email, password }) =>
  {
    return fetch(getRequestSign(email, password))
      .then((response) =>
      {
        if (response.status === 400)
          return Promise.reject();

        return response.json();
      })
      .then((data) =>
      {
        setCurrentUser(data.result.user);
        setCurrentAuth(data.result.auth);

        return Promise.resolve();
      })
      .catch((error) =>
      {
        return Promise.reject();
      });
  },
  logout: () =>
  {
    clearLocalStorage();

    return Promise.resolve();
  },
  checkError: (error) =>
  {
    if (error !== null && error !== undefined &&
        (error.status === 401 || error.status === 403))
    {
      clearLocalStorage();

      return Promise.reject();
    }

    return Promise.resolve();
  },
  checkAuth: () =>
  {
    return getCurrentUser() !== null ? Promise.resolve() : Promise.reject();
  },
  getIdentity: () =>
  {
    const currentUser = getCurrentUser();
    if (currentUser !== null)
    {
      return Promise.resolve(
      {
        id: currentUser.id,
        fullName: currentUser.name
      });
    }
    else
      return Promise.reject();
  },
  getPermissions: () =>
  {
    const currentUser = getCurrentUser();
    if (currentUser !== null)
      return Promise.resolve({ is_master: currentUser.is_master });
    else
      return Promise.reject();
  }
};

export default authProvider;
